(() => {
  'use strict';
  document.querySelectorAll('[data-pe-video]').forEach(figure => {
    const stage=figure.querySelector('.pe-video-stage');
    const play=figure.querySelector('[data-pe-video-play]');
    const close=figure.querySelector('[data-pe-video-close]');
    const original=play.cloneNode(true);
    const load=()=>{
      document.querySelectorAll('[data-pe-video-close]:not([hidden])').forEach(button=>button.click());
      const id=figure.dataset.videoId;
      if(!/^[A-Za-z0-9_-]{11}$/.test(id))return;
      const frame=document.createElement('iframe');
      const url=new URL('https://www.youtube-nocookie.com/embed/'+id);
      url.searchParams.set('start',String(Number(figure.dataset.videoStart)||0));
      url.searchParams.set('end',String(Number(figure.dataset.videoEnd)||60));
      url.searchParams.set('playsinline','1');
      url.searchParams.set('autoplay','1');
      url.searchParams.set('rel','0');
      // Playback is requested only by the explicit visitor click; no player exists on initial page load.
      frame.src=url.href;
      frame.title=figure.dataset.videoTitle;
      frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen=true;
      frame.referrerPolicy='strict-origin-when-cross-origin';
      stage.replaceChildren(frame);close.hidden=false;
      frame.focus();
    };
    play.addEventListener('click',load);
    close.addEventListener('click',()=>{const button=original.cloneNode(true);button.addEventListener('click',load);stage.replaceChildren(button);close.hidden=true;button.focus();});
    const group=figure.closest('details');
    if(group)group.addEventListener('toggle',()=>{if(!group.open&&!close.hidden)close.click();});
  });
  // Existing Placetel embeds, including players created by the tutorial filters, also receive source and channel links.
  let sourceData=null;
  const metadataURL=document.body.dataset.peVideoSourceUrl;
  let pending=false;
  async function creditExisting(){
    document.querySelectorAll('iframe[src*="dQw4w9WgXcQ"],iframe[src*="CBpFG2wKkTg"]').forEach(frame=>{const replacement=document.createElement('a');replacement.href='/#pe-videos';replacement.textContent='Telekommunikationsvideos →';const parent=frame.parentElement;if(parent.childElementCount===1)parent.replaceWith(replacement);else frame.replaceWith(replacement);});
    const frames=[...document.querySelectorAll('iframe[src*="youtube.com/embed/"],iframe[src*="youtube-nocookie.com/embed/"]')].filter(f=>!f.closest('[data-pe-video]')&&!f.dataset.peVideoCredited);
    if(!frames.length||pending||!metadataURL)return;
    pending=true;
    try{
      if(!sourceData){const response=await fetch(metadataURL);if(!response.ok)throw new Error('Source metadata unavailable');sourceData=await response.json();}
      frames.forEach(frame=>{
        const match=frame.src.match(/\/embed\/([\w-]{11})/);if(!match)return;
        const id=match[1],data=sourceData[id];if(!data)return;
        const caption=document.createElement('div');caption.className='pe-legacy-video-source';
        const label=document.createElement('strong');label.textContent=(document.body.dataset.peVideoSources||'Quellen')+': ';caption.append(label);
        const video=document.createElement('a');video.href='https://www.youtube.com/watch?v='+id;video.textContent=document.body.dataset.peVideoOriginal||'Originalvideo';video.target='_blank';video.rel='noopener';caption.append(video,document.createTextNode(' · '+data.author+' · '));
        const channel=document.createElement('a');channel.href=data.channel;channel.textContent=(document.body.dataset.peVideoChannel||'Kanal')+': '+data.channel;channel.target='_blank';channel.rel='noopener';caption.append(channel);
        const rights=document.createElement('p');rights.textContent=document.body.dataset.peVideoRights||'';caption.append(rights);
        frame.dataset.peVideoCredited='true';
        const card=frame.closest('.vc-card,.vc-video-card');
        if(card){card.append(caption);}else{frame.parentElement.insertAdjacentElement('afterend',caption);}
      });
    }catch(error){console.warn('Video source metadata could not be loaded.');}
    finally{pending=false;}
  }
  creditExisting();
  let timer;
  new MutationObserver(()=>{clearTimeout(timer);timer=setTimeout(creditExisting,80);}).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
})();
